import HTTPMethod from "./HTTPMethod.js"
import type { HTTPRequestBody } from "./HTTPRequestBody.js"
import HTTPRequestBuilder from "./HTTPRequestBuilder.js"

/**
 * @description
 *	An HTTP/HTTPS request.
 */
export default class HTTPRequest<I> {
	public readonly body: HTTPRequestBody
	public readonly headers: Record<string, string>
	public readonly method: HTTPMethod
	public readonly timeoutInMilliseconds: number
	public readonly uri: URL

	public constructor(builder: HTTPRequestBuilder<I>) {
		if (builder._body !== undefined && !HTTPRequest.allowsBody(builder._method)) {
			throw new Error(`${builder._method} request cannot have a body.`)
		}
		if (builder._uri === undefined) {
			throw new Error("The URI cannot be undefined.")
		}
		this.body = builder._body
		this.headers = builder._headers
		this.method = builder._method
		this.timeoutInMilliseconds = builder._timeoutInMilliseconds
		this.uri = builder._uri
	}

	/**
	 * @description
	 *	Indicates whether the method allows a body in a request or not.
	 */
	private static allowsBody(method: HTTPMethod): boolean {
		return [HTTPMethod.PATCH, HTTPMethod.POST, HTTPMethod.PUT].includes(method)
	}
}
